import MainLayout from "@/components/feature/MainLayout";
import { ladderPrices } from "@/mocks/price";

export default function LadderPricePage() {
  return (
    <MainLayout>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-bold text-gray-900">阶梯气价管理</h2>
          <button className="flex items-center gap-2 px-4 py-2 bg-[#E8531A] text-white text-sm rounded-lg cursor-pointer whitespace-nowrap">
            <i className="ri-add-line"></i>新增价格方案
          </button>
        </div>
        <div className="grid grid-cols-2 gap-4">
          {ladderPrices.map(lp => (
            <div key={lp.id} className="bg-white rounded-xl border border-gray-100 p-5">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h3 className="text-sm font-bold text-gray-900">{lp.userType}</h3>
                  <p className="text-xs text-gray-400 mt-0.5">适用区域：{lp.region} · 生效：{lp.effectiveDate}</p>
                </div>
                <span className="text-xs px-2 py-1 rounded-full bg-green-50 text-green-600">{lp.status}</span>
              </div>
              <div className="space-y-2">
                {lp.tiers.map(tier => (
                  <div key={tier.tier} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div>
                      <p className="text-xs font-medium text-gray-700">{tier.description}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-base font-bold text-[#E8531A]">{tier.price}</p>
                      <p className="text-xs text-gray-400">{tier.unit}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-4 flex gap-2">
                <button className="flex-1 py-2 text-xs border border-gray-200 rounded-lg text-gray-600 hover:bg-gray-50 cursor-pointer whitespace-nowrap">编辑</button>
                <button className="flex-1 py-2 text-xs bg-[#E8531A]/10 text-[#E8531A] rounded-lg hover:bg-[#E8531A]/20 cursor-pointer whitespace-nowrap">下发到设备</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </MainLayout>
  );
}
